import { useState } from "react";
import Box from "@mui/material/Box";
import {
  LeaderboardBreadcrumb,
  LeaderboardOrgDetail,
  LeaderboardPageHeader,
  LeaderboardPageShell,
  LeaderboardRankingTable,
  LeaderboardStatGrid,
  LeaderboardTabBar,
} from "./LeaderboardShared";
import {
  airportTabStats,
  demoAirports,
  demoNonprofits,
  demoPilots,
  leaderboardPeriodOptions,
  nonprofitTabStats,
  pilotTabStats,
} from "data/leaderboardDemoData";

const pilotColumns = [
  { key: "_rank", label: "#", align: "center", width: 52 },
  { key: "_entity", label: "Pilot" },
  { key: "missions", label: "Missions" },
  { key: "hours", label: "Hours" },
  { key: "avgPts", label: "Avg Pts" },
  { key: "_score", label: "Score" },
  { key: "_action", label: "" },
];

const airportColumns = [
  { key: "_rank", label: "#", align: "center", width: 52 },
  { key: "_entity", label: "Airport" },
  { key: "missions", label: "Missions" },
  { key: "fuelGal", label: "Fuel (gal)" },
  { key: "_score", label: "Score" },
  { key: "_action", label: "" },
];

const nonprofitColumns = [
  { key: "_rank", label: "#", align: "center", width: 52 },
  { key: "_entity", label: "Organization" },
  { key: "missions", label: "Missions" },
  { key: "patients", label: "Patients" },
  { key: "_score", label: "Score" },
  { key: "_action", label: "" },
];

function AdminLeaderboardView() {
  const [period, setPeriod] = useState(leaderboardPeriodOptions[0]);
  const [tab, setTab] = useState("pilots");
  const [detail, setDetail] = useState(null);

  if (detail) {
    return (
      <LeaderboardPageShell>
        <LeaderboardBreadcrumb current={detail.row.name} />
        <Box sx={{ mt: 2 }}>
          <LeaderboardOrgDetail
            entityType={detail.entityType}
            row={detail.row}
            onBack={() => setDetail(null)}
          />
        </Box>
      </LeaderboardPageShell>
    );
  }

  return (
    <LeaderboardPageShell>
      <LeaderboardBreadcrumb current="Leaderboards" />
      <LeaderboardPageHeader
        title="Mission Leaderboards"
        subtitle="Rankings across pilots, airports, and nonprofit partners"
        period={period}
        onPeriodChange={setPeriod}
      />
      <Box sx={{ mt: 3 }}>
        <LeaderboardTabBar
          tabs={[
            { id: "pilots", label: "Pilots", count: demoPilots.length },
            { id: "airports", label: "Airports", count: demoAirports.length },
            { id: "nonprofits", label: "Nonprofits", count: demoNonprofits.length },
          ]}
          active={tab}
          onChange={setTab}
        />

        {tab === "pilots" && (
          <>
            <LeaderboardStatGrid stats={pilotTabStats} />
            <LeaderboardRankingTable
              title="Pilot Rankings"
              searchPlaceholder="Search pilot…"
              columns={pilotColumns}
              rows={demoPilots}
              getRowId={(r) => r.id}
              onRowClick={(r) => setDetail({ row: r, entityType: "Pilot" })}
              filterKeys={["name", "sub", "location"]}
            />
          </>
        )}

        {tab === "airports" && (
          <>
            <LeaderboardStatGrid stats={airportTabStats} />
            <LeaderboardRankingTable
              title="Airport Rankings"
              searchPlaceholder="Search airport…"
              columns={airportColumns}
              rows={demoAirports}
              getRowId={(r) => r.id}
              onRowClick={(r) => setDetail({ row: r, entityType: "Airport" })}
              filterKeys={["name", "sub", "icao", "location"]}
            />
          </>
        )}

        {tab === "nonprofits" && (
          <>
            <LeaderboardStatGrid stats={nonprofitTabStats} />
            <LeaderboardRankingTable
              title="Nonprofit Rankings"
              searchPlaceholder="Search nonprofit…"
              columns={nonprofitColumns}
              rows={demoNonprofits}
              getRowId={(r) => r.id}
              onRowClick={(r) => setDetail({ row: r, entityType: "Nonprofit" })}
              filterKeys={["name", "sub", "location", "niche"]}
            />
          </>
        )}
      </Box>
    </LeaderboardPageShell>
  );
}

export default AdminLeaderboardView;
